import React from 'react';
import NoUiSlider from '@ro-forks/NoUiSlider';

import { Slider } from './UiSlider.styles';

class UiSlider extends React.Component {
  render() {
    return (
      <Slider className="ro-ui-slider">
        <NoUiSlider {...this.props} />
      </Slider>
    );
  }
}

export default UiSlider;
